export default "__VITE_ASSET__2d031ba3__"